import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../errorActionHandler";

export const getGroupManagementUserGroupActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserGroupData,
    setTempUserGroupData,
    setTotalRows
  ) =>
  async () => {
    await apis.admin.groupManagement
      .getUserGroup(pageNumber, pageSize, searchText)
      .then((response) => {
        setUserGroupData((prevStateData) => [
          ...prevStateData,
          ...response.data.UserGroups,
        ]);
        setTempUserGroupData((prevStateData) => [
          ...prevStateData,
          ...response.data.UserGroups,
        ]);
        setTotalRows(response.data.TotalLength);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const checkUniqueUserGroupNameActionHandler =
  (searchText) => async () => {
    const _ = undefined;
    return await apis.admin.groupManagement
      .checkUniqueUserGroupName(_, _, searchText)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postUserGroupActionHandler = (data) => async () => {
  return await apis.admin.groupManagement
    .postUserGroup(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteGroupActionHandler = (id) => async () => {
  return await apis.admin.groupManagement
    .deleteGroup(id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserGroupMembersHandler =
  (userGroupId, allHierarchicalMembers) => async () => {
    return await apis.admin.groupManagement
      .getUserGroupMembers(userGroupId, allHierarchicalMembers)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getUserByNameInGroupManagementActionHandler =
  (text) => async () => {
    return await apis.admin.groupManagement
      .getUserByName(text)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postMemberActionHandler = (id, data) => async () => {
  return await apis.admin.groupManagement
    .postMember(id, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteMemberActionHandler =
  (userGroupId, userId, getUserGroupMemeber) => async (dispatch) => {
    return await apis.admin.groupManagement
      .deleteMember(userGroupId, userId)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getSubgroupByIdActionHandler = (id) => async () => {
  return await apis.admin.groupManagement
    .getSubgroupById(id)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSubgroupActionHandler =
  (searchKey, isSearchToChildGroups, parentGroupId) => async () => {
    return await apis.admin.groupManagement
      .getSubgroup(searchKey, isSearchToChildGroups, parentGroupId)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const setSubgroupActionHandler = (id, data) => async () => {
  return await apis.admin.groupManagement
    .setSubgroup(id, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const deleteSubgroupActionHandler =
  (parentGroupId, subGroupId, getUserGroupMemeber) => async (dispatch) => {
    return await apis.admin.groupManagement
      .deleteSubgroup(parentGroupId, subGroupId)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getSearchClassActionHandler =
  (SearchText, Status, condition) => async () => {
    return await apis.admin.groupManagement
      .getSearchClass(SearchText, Status, condition)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getUserGroupsManadatedShotclassesActionHandler =
  (classtype, pageNum, pageSize, usergroupid) => async () => {
    return await apis.admin.groupManagement
      .getUserGroupsManadatedShotclasses(
        classtype,
        pageNum,
        pageSize,
        usergroupid
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const deleteMandatedClassesActionHandler =
  (classid, usergroupid) => async () => {
    return await apis.admin.groupManagement
      .deleteMandatedClasses(classid, usergroupid)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const deleteMandatedProgramActionHandler =
  (programid, usergroupid) => async () => {
    return await apis.admin.groupManagement
      .deleteMandatedProgram(programid, usergroupid)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const mandatedClassesActionHandler =
  (classid, usergroupid, Isrepetitive, Frequency) => async () => {
    return await apis.admin.groupManagement
      .mandatedClasses(classid, usergroupid, Isrepetitive, Frequency)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const mandateProgramActionHandler =
  (programid, usergroupid, Isrepetitive, Frequency) => async () => {
    return await apis.admin.groupManagement
      .mandateProgram(programid, usergroupid, Isrepetitive, Frequency)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getSearchProgramsActionHandler =
  (IsSkipduedateProgram, SearchText, Status) => async () => {
    return await apis.admin.groupManagement
      .getSearchPrograms(IsSkipduedateProgram, SearchText, Status)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getClassAndCollectionByProgramIdActionHandler =
  (ProgramID, locale) => async () => {
    return await apis.admin.groupManagement
      .getClassAndCollectionByProgramId(ProgramID, locale)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };
